// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1s5-4","content":"ManualTimeModal_content__3QDlx"};